/**
 * 사업자몰 통합검색에서 사용하는 필터레이어
 *
 * DIT 2.0
 *  - 같은 폴더 filterLayer_VIO23.js 기반으로 작성
 *
 * @since 2023.10.23
 */
var FilterLayer = (function () {
	// 문자열 전체 공백제거 함수
	var removeSpaces = function (val) {
		return val.replace(/\s+/g, "");
	};

	// 특수문자 제거 함수
	var removeSpecials = function (val) {
		return val.replace(/[^\w|\u3131-\u318E\uAC00-\uD7A3]/g, "");
	};

	// b필터 유닛
	// prettier-ignore
	var tempUnitBtn =
		'{{#each (item, idx) in data.filterValues}}{{#if item.count != "0"}}<li class="{{#if item.filterValueId == act}}on{{/if}}">' +
			'<a href="#{{item.filterValueId}}">{{item.filterValueName}}<em class="blind">선택됨</em></a>' +
		'</li>{{/if}}{{/each}}';
	
	// b필터 선택 태그 리스트
	// prettier-ignore
	var tempSelectTag =
		'{{#each item in data}}'+
			'<li>'+
				'<div class="s-fliter">'+
					'<span>{{item.label}}</span>'+
					'<button type="button" data-unit="{{unitName}}" data-contents="{{#raw filterId}}" data-value="{{#raw item.value}}" class="btn-del">'+
						'<span class="blind">삭제</span>'+
					'</button>'+
				'</div>'+
			'</li>'+
		'{{/each}}';
	
	// b필터 유닛별 그룹핑 (아코디언 컨테이너)
	// prettier-ignore
	var tempBfilterGroup =
		'<div class="filter-inner" data-filter-group-id="{{unitName}}">' +
			'{{#if unitName != "unit"}}<p class="filter-tit">{{unitNameKor}}</p>{{/if}}' +
			'<div class="list-acco ui_filter_accordion ui_accordion {{unitName}}" style="{{#if unitName == "unit"}}display:none{{/if}}">' +
				'<ul></ul>' +
			'</div></div>';

	// unit 상태 정보
	// prettier-ignore
	var templateUnitTop =
		'<div class="tit_result">' + 
			'<div class="tit_result_count">{{filterGroupName}}</div>' +
			'{{#if unitName != "unit"}}' +
				'{{#if (_id != "색상")}} <div class="tit_result_content"></div>' +
				'{{#else}} <div class="tit_result_colorchip"></div>' +
				'{{/if}}' + 
				'<div class="tit_result_text"></div>' +
			'{{/if}}' + 
		'</div>';

	// 색상
	// prettier-ignore
	var tempColor = 
		'<div class="chk-wrap-colorchip {{#if item.filterCode != ""}}{{item.filterCode}}{{#else}}onlytext{{/if}}">' +
			'<input type="checkbox" name="{{area}}-{{unitName}}-{{_id}}" value="{{item.filterValueId}}" id="{{area}}-color-{{unitName}}-{{_id}}-{{#raw item._idx}}" data-contents="{{#raw filterGroupName}}" {{#if item._filterEnable == "N"}}disabled{{/if}}>' +
			'<label for="{{area}}-color-{{unitName}}-{{_id}}-{{#raw item._idx}}">{{item.filterValueName}}</label>' +
		'</div>';

	// 라디오
	// prettier-ignore
	var tempRadio = 
		'<div class="rdo-wrap">' +
			'<input type="radio" name="{{area}}-{{unitName}}-{{_id}}" value="{{item.filterValueId}}" id="{{area}}-rdo-{{unitName}}-{{_id}}-{{#raw idx}}" data-contents="{{#raw filterGroupName}}" {{#if idx==0}}checked{{/if}} {{#if item._filterEnable == "N"}}disabled{{/if}}>' +
			'<label for="{{area}}-rdo-{{unitName}}-{{_id}}-{{#raw idx}}">{{item.filterValueName}}</label>' +
		'</div>';

	// 체크박스
	// prettier-ignore
	var tempCheckbox = 
		'{{#if (isEmp == false && item.filterValueId == "partner") || item.filterValueId == "employee"}}{{#else}}<div class="chk-wrap">' +
			'<input type="checkbox" name="{{area}}-{{unitName}}-{{_id}}" value="{{item.filterValueId}}" id="{{area}}-chk-{{unitName}}-{{_id}}-{{#raw idx}}" data-contents="{{#raw filterGroupName}}" {{#if item.count == "0" || item._filterEnable == "N"}}disabled{{/if}}>' +
			'<label for="{{area}}-chk-{{unitName}}-{{_id}}-{{#raw idx}}">{{item.filterValueName}}</label>' +
		'</div>{{/if}}';
	
	// prettier-ignore
	var tempSpanCheckbox = 
		'{{#if (isEmp == false && item.filterValueId == "partner") || item.filterValueId == "employee"}}{{#else}}'+
			'<span class="chk-wrap {{#if item.filterValueId === "tomorrow"}} tomorrow-delivery{{/if}}">' +
				'<input type="checkbox" name="{{area}}-{{unitName}}-{{_id}}" value="{{item.filterValueId}}" id="{{area}}-chk-{{unitName}}-{{_id}}-{{#raw idx}}" data-contents="{{#raw filterGroupName}}" {{#if item.count == "0" || item._filterEnable == "N"}}disabled{{/if}}>' +
				'<label for="{{area}}-chk-{{unitName}}-{{_id}}-{{#raw idx}}">{{item.filterValueName}}</label>' +
		'</span>{{/if}}';
	
	// prettier-ignore
	var unitTopTitleTemplate =
		'{{#if _empDispYn === "Y" }}' + 
			'<li data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-smart="{{smart}}" data-filter-unit="{{unitName}}">' +
				'<div class="flex-chk-wrap top-sort type-flex" data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-unit="{{unitName}}">' +
					'<p class="blind tit_result_count">{{unitName}}</p>' +
					'{{#each (item, idx) in filterValues}}' + 
						'{{_input_}}' +
					'{{/each}}' +
				'</div>'+
			'</li>' +
		'{{/if}}';
	
	// prettier-ignore
	var topTagTemplate =
		'<li data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-smart="{{smart}}" data-filter-unit="{{unitName}}" class="on">' +
			'<div class="flex-chk-wrap top-sort-content check-filter type-flex" data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-unit="{{unitName}}">' +
				'<div class="tit_result_count" style="display: none;">{{unitName}}</div>' +
					'<ul>'+
						'<li>'+
							'{{#each (item, idx) in filterValues}}' + 
								'{{_input_}}' +
							'{{/each}}' +
						'</li>'+
					'</ul>'+
				'</div>' +
			'</div>' +
		'</li>';
	
	// prettier-ignore
	var tempAccordion =
		'<li data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-smart="{{smart}}" data-filter-unit="{{unitName}}">' +
			'<div class="head">' +
				'<a href="#{{_id}}-{{unitName}}-{{#raw index}}" class="link-acco ui_accord_toggle" data-contents="{{#raw filterGroupName}}" data-open-text="내용 더 보기" data-close-text="내용 닫기">' +
					'<div class="tit">' + templateUnitTop + '</div>' +
					'<span class="blind ui_accord_text">내용 더 보기</span>' +
				'</a>' +
			'</div>' +
			'<div class="desc ui_accord_content {{#if _id != "브랜드"}} type-width-auto{{/if}}" id="{{_id}}-{{unitName}}-{{#raw index}}">' +
				'{{#if (_filterInfoYN === "Y") }}' + 
					'<div class="filter_tooltip_wrap">' +
						'<div class="tit_tooltip">' +
							'<button type="button" class="btn-dict" data-href="#popupDictionary" data-control="modal" data-info-Type="{{_filterInfoType}}" data-info-Url="{{_filterInfoAjaxUrl}}">' +
							'{{_filterInfoTitle}}</button>' +
						'</div>' +
					'</div>' +
				'{{/if}}' +
				'{{#if (_id == "색상" || _id == "colors" || filterType == "color" )}}' + 
					'{{#if filterValues_Sold.length}}<div class="colorchip_tit" {{#if filterValues_Objet.length == 0}}style="display:none;"{{/if}}>솔리드 색상</div>' +
						'<div class="flex-chk-wrap type-colorchip">{{#each item in filterValues_Sold}}' + 
							'{{_input_}}' +
						'{{/each}}</div>' +
					'{{/if}}' +
					'{{#if filterValues_Objet.length}}<div class="colorchip_tit objet" {{#if filterValues_Sold.length == 0}}style="display:none;"{{/if}}>멀티 색상</div>' +
						'<div class="flex-chk-wrap type-colorchip">{{#each item in filterValues_Objet}}' + 
							'{{_input_}}' +
						'{{/each}}</div>' + 
					'{{/if}}' +
				'{{#else}}' +
					'<div class="flex-chk-wrap check-filter">'+
						'{{#each (item, idx) in filterValues}}' + 
							'{{_input_}}' +
						'{{/each}}' +
					'</div>' +
				'{{/if}}' + 
			'</div>' +
		'</li>';
	
	// 가격
	// prettier-ignore
	var tempRangeSlider = 
		'<div class="range-wrap">' +
			'<div name="{{area}}-{{unitName}}-{{_id}}" class="ui_slider ui_price_slider" data-input="{{_range}}" data-range="{{_range}}" data-suffix="원"></div>' +
			'<p class="min range-num"></p>' +
			'<p class="max range-num"></p>' +
		'</div>';
	
	// prettier-ignore
	var priceTemplate =
		'<li data-filter-id="{{_id}}" data-contents="{{#raw filterId}}" data-filter-smart="{{smart}}" data-filter-unit="{{unitName}}" class="open on">'+
			'<div class="head">'+
				'<a href="#{{_id}}-{{unitName}}-{{#raw index}}" class="link-acco" data-contents="{{#raw filterGroupName}}" data-open-text="내용 더 보기" data-close-text="내용 닫기">' +
					'<div class="tit">' + templateUnitTop + '</div>'+
					'<span class="blind ui_accord_text">내용 더 보기</span>'+
				'</a>'+
			'</div>'+
			'<div class="desc ui_accord_content type-width-auto prod-price-setup" id="{{_id}}-{{unitName}}-{{#raw index}}">' +
				'<div class="cont">'+
					'{{#each (item, idx) in filterValues}}'+
						tempRangeSlider +
					'{{/each}}' +
				'</div>' +
			'</div>'+
		'</li>';

	// 스마트 필터 용어사전
	// prettier-ignore
	var grossaryTemplate =
		'<header class="pop-header"><h1 class="tit"><span>용어사전</span></h1></header>'+
			'<section class="pop-conts glossary-cont no-footer">'+
				'{{#if pcThumbnailPath}}' +
					'<figure class="banner">'+
						'<img src="{{pcThumbnailPath}}{{pcThumbnailName}}" alt="{{pcThumbnailAltText}}" class="pc-only">'+
						'<img src="{{mobileThumbnailPath}}{{mobileThumbnailName}}" alt="{{mobileThumbnailAltText}}" class="mo-only">'+
						'<figcaption class="blind">{{pcThumbnailAltText}}</figcaption>'+
					'</figure>'+
				'{{/if}}' +
				'<strong class="add-tit">{{descriptionTitle}}</strong>'+
				'<p class="add-txt">{{description}}</p>'+
				'<h3 class="sub-tit">[종류]</h3>'+
				'<ul class="list-item">'+
					'{{#each (item, idx) in items}}' +
					'<li>'+
						'<div class="item-box">'+
							'<span class="thum"><img src="{{item.pcThumbnailPath}}{{item.pcThumbnailName}}" alt="{{item.pcThumbnailAltText}}"></span>'+
							'<strong class="title">{{item.descriptionTitle}}</strong>'+
							'<p class="description">{{item.description}}</p>'+
						'</div>'+
					'</li>'+
					'{{/each}}' +
				'</ul>'+
			'</section>'+
			'<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';

	// 스펙 용어사전 연동
	// prettier-ignore
	var specGrossaryTemplate = 
		'<header class="pop-header">' +
			'<h1 class="tit"><span>{{specName}}</span></h1>' +
		'</header>' +
		'<section class="pop-conts">' +
			'<div class="pop-inner">' +
				'{{#if type == "T"}}' +
				  '<p class="add-txt">{{#raw description}}</p>' +
				'{{/if}}' +
				'{{#if type == "H"}}' +
					'{{#raw contents}}' +
				'{{/if}}' +
				'{{#if type == "I"}}' +
					'<figure class="banner">' +
						'<img src="{{contents}}" alt="{{imageAltText}}" class="pc-only">' +
						'<img src="{{contents}}" alt="{{imageAltText}}" class="mo-only">' +
						'<figcaption class="blind">{{#raw description}}</figcaption>' +
					'</figure>' +
				'{{/if}}' +
				'{{#if type == "V"}}' +
					'<div class="media-wrap spec-video">' +
						'<div class="video-wrap">' +
							'<video autoplay src="{{contents}}" class="pop-video" muted loop playsinline controls style="background-color: rgb(0, 0, 0);"></video>' +
						'</div>' +
					'</div>' +
					'<p class="add-txt">{{#raw description}}</p>' +
				'{{/if}}' +
			'</div>' +
		'</section>' +
		'<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';
	
	// 스펙 용어사전 연동
	// prettier-ignore
	var specGrossarySliderTemplate = 
		'<header class="pop-header">' +
			'<h1 class="tit"><span>{{data[0].specName}}</span></h1>' +
		'</header>' +
		'<section class="pop-conts">' +
			'<div class="media-wrap dictionary-slider-wrap">' +
				'<div class="ui_carousel_list">' +
					'<div class="items-group component-inner-box ui_carousel_slider">' +
						'<div class="items ui_carousel_track">' +
							'{{#each (item, idx) in data}}' +
								'<div class="item item-box ui_carousel_slide">' +
									'<div class="visual-wrap">' +
										'<div class="visual-area image">' +
											'<img src="{{item.contents}}" alt="{{item.imageAltText}}">' +
										'</div>' +
									'</div>' +
								'</div>' +
							'{{/each}}' +
						'</div>' +
						'<div class="slide-controls">' +
							'<button type="button" class="btn-arrow prev ui_carousel_prev"><span class="blind">이전</span></button>' +
							'<div class="slide-number"><strong class="current">1</strong><span>8</span></div>' +
								'<button type="button" class="btn-arrow next ui_carousel_next"><span class="blind">다음</span></button>' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<p class="add-txt">{{#raw data[0].description}}</p>' +
			'</div>' +
		'</section>' +
		'<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>';    
	
	var AFilter = function (target, filterLayer) {
		var self = this;
	
		self.filterLayer = filterLayer;
		self.$aFilterUnitCon = target;
		self.$aFilterSwiperTabCon = target.siblings(".nafilter_anchor");
		self.$aFilterTagCon = target.siblings(".nafilter_choice");
		self.multiLineSwiper = false; // swiper 2줄 유무
	
		self._setting();
		self._bindEvents();
	};

	AFilter.prototype = {
		_temp: {
			// 유닛
			// prettier-ignore
			unitBtn : 
				'{{#each (item, idx) in data.filterValues}}{{#if item.count != "0"}}<li class="{{#if item.filterValueId == act}}on{{/if}}">' +
					'<a href="#{{item.filterValueId}}">{{item.filterValueName}}<em class="blind">선택됨</em></a>' +
				'</li>{{/if}}{{/each}}',
			
			// a필터 탭 버튼
			// prettier-ignore
			tabBtn :
				'{{#each (item, idx) in filters}}<li class="{{unitName}}">' +
					'<a href="#afilter-tab-{{unitName}}-{{item._id}}">' +
						'{{item.filterGroupName}}<em class="blind"></em>' + 
					'</a>' +
				'</li>{{/each}}',
			
			// a필터 input
			// prettier-ignore
			filterItem : 
				'<div class="group" data-unit="{{unitName}}">' +
					'{{#each (item, idx) in filterValues}}' + 
						'<li>{{_input_}}</li>' +
					'{{/each}}' +  
				'</div>',
			
			// a필터 swiper slide
			// prettier-ignore
			slide: '<div class="swiper-slide" data-unit="{{unitName}}" data-id="{{area}}-tab-{{unitName}}-{{_id}}"><ul></ul></div>',
			
			// a필터 swiper 안내 표시
			// prettier-ignore
			slideInfo:
				// 안내문구if
				'{{#if (_filterInfoYN === "Y") }}' + 
					'<div class="head anchor-txt2">' +
						'<button type="button" class="slide-btn" data-href="#popupDictionary" data-control="modal" data-info-Type="{{_filterInfoType}}" data-info-Url="{{_filterInfoAjaxUrl}}">' +
							'<p>{{_filterInfoTitle}}</p>' +
							'<div class="tooltip-wrap">' +
								'<span class="tooltip-icon ui_tooltip-target" ui-modules="TooltipTarget"></span>' +
							'</div>' +
						'</button>' +
					'</div>' +
				'{{/if}}',
			
			
			// a필터 선택 태그 리스트
			// prettier-ignore
			selectTag: '{{#each item in data}}<li>' +
				'<span>{{item.label}}</span>' +
				'<a href="#n" data-unit="{{unitName}}" data-contents="{{#raw filterId}}" data-value="{{#raw item.value}}">삭제</a>' +
			'</li>{{/each}}',
		},
		_setting: function () {
			var self = this;
		},
		_bindEvents: function () {
			var self = this;
		
			// 유닛탭 클릭
			self.$aFilterUnitCon.on("click", "li > a", function (e) {
				var target = $(e.currentTarget);
				var unitName = target.attr("href").replace("#", "");
			
				e.preventDefault();
			
				self.filterLayer.changeUnitTab(unitName);
			});
			
			// swiper 내에 input change 이벤트
			self.$aFilterSwiperTabCon.on(
				"change",
				".swiper input[id^=afilter]",
				function (e) {
					var target = $(e.currentTarget);
			
					self.filterLayer.changeBfilter(target);
				}
			);
			
			// 선택 태그 아이템 x 버튼 클릭
			self.$aFilterTagCon.on("click", ".choice_item li > a", function (e) {
				e.preventDefault();
				
				var target = $(e.currentTarget);
				var unitName = target.data("unit");
				var id = target.data("contents");
				var value = target.data("value");
				
				var $selectTagDIV = self.filterLayer.$layFilter.find(".s-filter-list");
				var $selectedTagLI = $selectTagDIV.find("> li");
				
				var aTag = $selectedTagLI.find(
					'button[data-unit="'+ unitName +'"][data-contents="'+ id +'"][data-value="' + value +'"]'
				);
				
				// bfilter tag x 버튼 클릭 발생
				aTag.trigger("click");
			});
			
			// tag 리셋
			self.$aFilterTagCon.on("click", ".item_reset > a", function (e) {
				e.preventDefault();
			
				self.filterLayer.resetBfilter();
			});
		},
		/**
		 * afilter 생성
		 */
		create: function () {
			var self = this;
			
			// save ui state
			self.saveUIState();
			
			// unit wrap
			self.$aFilterUnitCon.find("> ul.tabs").empty();
			
			// btn wrap
			self.$aFilterSwiperTabCon.find(".anchor_tabs > ul.tabs").empty();
			
			// swiper
			self.$aFilterSwiperTabCon.find(".anchor_list > .swiper").html('<div class="swiper-wrapper"></div><div class="swiper-pagination"></div>');
			
			// tag wrap
			self.$aFilterTagCon.find(".choice_item > ul").empty();
		},
		/**
		 * vcui 초기화
		 */
		initVcui: function () {
			var self = this;
			
			// unit tab
			var unitTab = self.$aFilterUnitCon.data("ui_tab");
			if (unitTab) unitTab.update();
			
			// filter tab
			var $afilterTabDIV = self.$aFilterSwiperTabCon.find(".anchor_tabs");
			var filterTab = $afilterTabDIV.data("ui_tab");
			if (filterTab) {
				filterTab.update();
				filterTab.select(0);
			}
		
			// tab 추가 click 이벤트
			$afilterTabDIV.on("click", "a", function (e) {
				var btn = $(e.currentTarget);
				var idx = btn.closest("li").index();
				
				if (swiper) {
					var href = btn.attr("href");
					var btnId = href.replace("#", "");
					
					var $slide = $(swiper.slides[swiper.activeIndex]);
					var unitName = $slide.attr("data-unit");
					var id = $slide.attr("data-id");
					var slideId = "afilter-tab-" + unitName + "-" + id;
					
					// 현재 활성화된 btn id와 slide id가 다른 경우 그 다른 slide 중 첫번째 활성화
					if (encodeURI(btnId) !== encodeURI(slideId)) {
						var first = $(swiper.slides)
							.filter("[data-id='" + btnId + "']")
							.first();
						
						if (first.length) swiper.slideTo(first.index());
					}
				}
			});
		
			var swiperChange = function (data) {
				var self = this;
				var container = data.$el;
				var wrapper = data.$wrapperEl;
				
				var max = container.find(".swiper-pagination > span").length;
				var idx = container
							.find(".swiper-pagination .swiper-pagination-bullet-active")
							.index() || data.activeIndex;
				
				var $slideLI = $(data.slides[idx]);
				var id = $slideLI.attr("data-id");
				
				if (id) {
					var $afilterTabDIV = self.$aFilterSwiperTabCon.find(".anchor_tabs");
					self.changeTab($afilterTabDIV, id);
				}
			};
		
			// 재검색 시 초기 index 미리 지정
			var activeIndex = self.filterLayer.getUIState("afilter.slide") || 0;
			
			// 스와이퍼
			var $swiper = self.$aFilterSwiperTabCon.find(".anchor_list > .swiper");
			if (self.multiLineSwiper) $swiper.addClass("multi");
			if (!!$swiper.length) {
				var swiper = new Swiper($swiper[0], {
					effect: "creative",
					initialSlide: activeIndex,
					creativeEffect: {
						prev: {
							translate: ["-100%", 0, -1],
						},
						next: {
							translate: ["100%", 0, -1],
						},
					},
					pagination: {
						el: ".swiper-pagination",
						type: "bullets",
						clickable: true,
					},
					on: {
						/* slideChangeStart: swiperChange.bind(this),
						sliderMove: swiperChange.bind(this), */
						transitionEnd: swiperChange.bind(this),
						init: function () {
							self.$aFilterSwiperTabCon.toggle(!!this.slides.length);
						},
					},
					a11y: {
						paginationBulletMessage: "{{index}} 번 내용 보기",
					},
					autoHeight: true
				});
			}
		},
		/**
		 * 유닛 버튼 생성
		 * @param {string} unitName 유닛명
		 * @param {array} unitFilters 노출할 필터 배열
		 */
		createUnitBtn: function (unitName, unitFilters) {
			var self = this;
			var $unitListUL = self.$aFilterUnitCon.find("ul.tabs");
			
			if (unitName !== "unit") return;
			
			var values = _.get(unitFilters, "[0].filterValues");
			
			// 재검색 시 활성화 기억
			var unitTabId = self.filterLayer.getUIState("afilter.unit");
			
			if (!!values.length) {
				$unitListUL.html(
					vcui.template(self._temp.unitBtn, {
						data: unitFilters[0],
						act: unitTabId,
					})
				);
			}
		},
		/**
		 * 필터 버튼 생성
		 * @param {string} unitName 유닛명
		 * @param {array} unitFilters 노출할 필터 배열
		 */
		createFilterBtn: function (unitName, unitFilters) {
			var self = this;
			var $tabUL = self.$aFilterSwiperTabCon.find(".anchor_tabs > ul.tabs");
			
			// smart필터가 아니거나 range 형 비노출 (e.g 가격, 색상)
			unitFilters = _.filter(unitFilters, function (item) {
				// filterId 빈문자 제거해 id 용도로 사용
				item._id = removeSpecials(removeSpaces(item.filterId));
			
				return !((item.smart === "N" || item.filterGroupType === "range" || item.filterSmartFilterFlag != 'Y'));
			});
			
			// tab btn
			$tabUL.append(
				vcui.template(self._temp.tabBtn, {
					unitName: unitName,
					filters: unitFilters, // [{filterId: '제품타입', ... }, {filterId: '공기청정면적', ... }, ..]
				})
			);
			
			// afilter 영역 노출 - (self.AFilter.breakpointChecker(); : 관련 펑션)
			if(breakpoint.name == 'mobile') {
				var $aFilterTabCon = $(".search-result-wrap .nafilter_anchor");
				if (!!$aFilterTabCon.find('.tabs > li').length) {
					$aFilterTabCon.show();
				}
			}
		},
		/**
		 * 필터 스와이퍼 추가 (필터 만큼 반복)
		 * @param {string} unitName 유닛명
		 * @param {object} data vcui.template 전달할 data // {filterId: '공기청정면적', ... }
		 * @param {string} input input template
		 * @returns
		 */
		addSwiperSlide: function (unitName, data, input) {
			var self = this;
			var $swiperContainer = self.$aFilterSwiperTabCon.find(".anchor_list > .swiper");
			var $swiperWrapper = $swiperContainer.find(".swiper-wrapper");
			
			// smart필터가 아니거나 range 형 비노출 (e.g 가격, 색상)
			if (data.smart === "N" || data.filterGroupType === "range" || data.filterSmartFilterFlag != 'Y') return;
			
			// {filterId: '제품타임', filterValues: [..], ..}
			data.area = "afilter";
			data.unitName = unitName;
			
			// li > input
			$swiperWrapper.append(
				vcui.template(self._temp.filterItem.replace(/\{\{\_input\_\}\}/g, input), data)
			);
			
			var $groupDIV = $swiperWrapper.find(".group").last();
			var $slides = $groupDIV.find("li");
			var groupNum = 4;
			
			var $groupSlide = $slides.slice(i, i + groupNum);
			// 4개씩 그룹핑
			for (var i = 0; i < $slides.length; i += groupNum) {
				$groupSlide = $slides.slice(i, i + groupNum);
			
				// 2줄 짜리 유무
				if (!self.multiLineSwiper && $groupSlide.length > 2) {
					self.multiLineSwiper = true;
				}
				
				$groupSlide.wrapAll(vcui.template(self._temp.slide, data));
			}
			// a필터 안내 표시
			$groupDIV.find(".swiper-slide").prepend(vcui.template(self._temp.slideInfo, data)) 
			// b필터의 div.chk-wrap 제거
			$groupDIV.find("input").each(function (idx, item) {
			  $(item).unwrap();
			});
			
			// .swiper-slide를 .group 밖으로
			$groupDIV.find(".swiper-slide").appendTo($swiperWrapper);
			
			// .group 제거
			$groupDIV.remove();
		},

		/**
		 * 태그형 샹태 갱신
		 */
		refreshTag: function () {
			var self = this;
			var $selectTagDIV = self.$aFilterTagCon.find(".choice_item");
			var $selectedTagLI = $selectTagDIV.find("> ul > li");
			var $countSPAN = self.$aFilterTagCon.find(".btn-filter > .filter_count");
			var $msgDIV = self.$aFilterTagCon.find(".choice_base");
			
			$msgDIV.toggle(!$selectedTagLI.length);
			$selectTagDIV.toggle(!!$selectedTagLI.length);
			
			$countSPAN
				.toggle($selectedTagLI.length !== 0)
				.text($selectedTagLI.length);
			
			$countSPAN
				.parent()
				.find(".blind")
				.text(!!$selectedTagLI.length ? "옵션 적용됨" : "옵션");
		},

		/**
		 * 태그형 추가
		 * @param {string} unitName 유닛명
		 * @param {string} filterId 필터 id
		 * @param {array} selectedArr 선택된 배열
		 * @returns
		 */
		addTag: function (unitName, filterId, selectedArr) {
			var self = this;
		
			// "검색결과" 는 tag 리스트 안 쌓음
			if (unitName === "unit") return;
			
			// 선택 tag 리스트
			var $selectTagUL = self.$aFilterTagCon.find(".choice_item > ul");
			
			$selectTagUL.append(
				vcui.template(self._temp.selectTag, {
					unitName: unitName,
					filterId: filterId,
					data: selectedArr,
				})
			);
		},

		/**
		 * 탭 활성화 변경 (첫번째 인자로 A필터에 (2개)중 한개 선택 변경)
		 * @param {jQueryElement} $tab // vcTab 적용된 element
		 * @param {string} id // 버튼 a태그 href #뺀 id
		 */
		changeTab: function ($tab, id) {
			var self = this;
			var $tabA = $tab.find("a[href='#" + id + "']");
			if (!$tabA.length) return;
		
			var tab = $tab.data("ui_tab");
			var $li = $tabA.closest("li");
			var idx = $li.index();
			var marginLeft = parseInt($li.css("marginLeft"));
		
			if (tab) {
				tab.select(idx);
				var left = $li.get(0).offsetLeft - marginLeft;
					left = left - 16;		// 첫번째 탭 영역 위치 처리(-16) 
				
				$tabA.closest(".tabs")
				.get(0)
				.scrollTo({ left: left, behavior: "smooth" });
			}
			
		},

		/**
		 * 스크롤에 따른 스위칭
		 * @param {string} unitName 유닛명
		 */
		toggle: function (unitName) {
			var self = this;
			
			// 유닛탭 활성화 변경
			self.changeTab(self.$aFilterUnitCon, unitName);
			
			// 유닛탭 활성화 기억
			// intersection scrollDirection의 방향과 상관없이 활성화 기억을 위해
			self.filterLayer.setUIState("afilter.unit", unitName);
		},

		/**
		 * ui 상태 저장
		 */
		saveUIState: function () {
			var self = this;
			
			// 유닛탭 활성화 기억은 toggle() 에서만 저장
			// 재검색 시 create(), toggle() 각각 실행으로 saveUISate() 두번 실행되는것 때문에
			
			// 필터탭 활성화 기억
			var filterTabActA = self.$aFilterSwiperTabCon.find("ul.tabs > li.on > a");
			self.filterLayer.setUIState(
				"afilter.filter",
				filterTabActA.length
					? filterTabActA.attr("href").replace("#", "")
					: null
			);
			
			// 스와이퍼 활성화 기억
			var $swiper = self.$aFilterSwiperTabCon.find(".anchor_list > .swiper");
			if (!!$swiper.length && $swiper[0].swiper) {
				var swiper = $swiper[0].swiper;
			
				self.filterLayer.setUIState("afilter.slide", swiper.activeIndex);
			}

			// tag 스크롤 기억
			var $selectTagUL = self.$aFilterTagCon.find(".choice_item > ul");
			var tagxpos = $selectTagUL.scrollLeft() || 0;
			self.filterLayer.setUIState("afilter.tagxpos", tagxpos);
		},

		/**
		 * ui 상태 복구함수
		 */
		restoreUIState: function () {
			var self = this;
			
			// 저장된 필터탭
			var unitTabId = self.filterLayer.getUIState("afilter.unit");
			
			// 유닛탭 활성화 복구
			if (unitTabId) {
				// 유닛탭 활성화 복구
				self.changeTab(self.$aFilterUnitCon, unitTabId);
			}
			
			// 스와이퍼 위치 복구
			var $swiper = self.$aFilterSwiperTabCon.find(".anchor_list > .swiper");
			if (!!$swiper.length && $swiper[0].swiper) {
				var swiper = $swiper[0].swiper;
				
				var activeIndex = self.filterLayer.getUIState("afilter.slide");
				swiper.slideTo(activeIndex, 0); // swiperChange() 에서 self.changeTab() 필터탭 활성화 복구
			}
			
			// tag 스크롤 복구
			var $selectTagUL = self.$aFilterTagCon.find(".choice_item > ul");
			var tagxpos = self.filterLayer.getUIState("afilter.tagxpos") || 0;
			$selectTagUL.scrollLeft(tagxpos);
		},
		
		// 미디어 쿼리
		breakpointChecker: function () {
			var self = this;
			var breakpoint = window.breakpoint;
			
			switch (breakpoint.name) {
				case "pc":
					self.$aFilterSwiperTabCon.hide();
					break;
				case "mobile":
					if(self.$aFilterSwiperTabCon && !!$('div.nafilter_anchor .tabs > li').length) {
						var $swiper = self.$aFilterSwiperTabCon.find(".anchor_list .swiper");
						if (!!$swiper.length && $swiper[0].swiper) {
							var swiper = $swiper[0].swiper;
							
							self.$aFilterSwiperTabCon.toggle(swiper.slides.enabled);
						}
					} else {
						self.$aFilterSwiperTabCon.hide();
					} 
				break;
				default:
			}
		},
	};

	function FilterLayer() {
		var self = this;

		self.args = arguments;
		self.uniqId = vcui.getUniqId(8); // 8자 유니크한 id
		self.resultData = null; // ajax 결과 데이터
		self.filterData = null; // 마크업 생성해야할 필터 데이터
		self.selectedData = null; // 세션 저장 데이터
		self.units = [
			"product",
			/* "support",   */
			"event",
		]; // "검색결과" 내에 표현 가능한 input의 key값, 해당 key만 json에서 가져와 표현

		self.intersection 	   = null; // filter unit별 토글링 위한 intersection
		self.activatedUnitName = null; // 활성화된 유닛명 저장 변수
		self.device = "";	  // pc || mobile
		self.uiState = {
			bfilter: {
				unit: null,   // B필터 유닛 탭 id
				ypos: 0,	  // B필터 scroll ypos
			},
			afilter: {
				unit: null,	  // A필터 유닛 탭 id
				filter: null, // A필터 필터 탭 활성화 id
				slide: 0,	  // A필터 슬라이드 index
				tagxpos: 0,	  // A필터형 태그 scroll xpos
			},
		};

		vcui.require([
			 "ui/rangeSlider",
			],
			function () {
				self._setting.apply(self, self.args);
				self._bindEvents();
				
				self.loaded = true;
				self.breakpointChecker();
				
				// new 로 객체 생성보다 느리기 때문 require 완료 시 self 에 저장된 데이터로 셋팅
				self.create(self.resultData, self.selectedData);
				self.select(self.selectedData, self.isTrigger);
				
				// 리스트 출력 trigger 이벤트
				self.$layFilter.trigger("loaded");
			}
		);
	}

	//public
	FilterLayer.prototype = {
		event: {
				  CLICK_UNIT_TAB: "click_unit_tab"
				, READY_RESTORE : "ready_restore"
		},
		_setting: function (
				  $targetFilter
				, $resultWrap
				, $aFilterTab
				, callbackChangeEvent
		) {
			
			var self = this;
			// 외부에서 받을 element
			self.$layFilter = $targetFilter;
			self.$resultWrap = $resultWrap; // 검색 결과 노출 wrap
			self.$aFilterTab = $aFilterTab; // a필터 탭
			self.AFilter = new AFilter($aFilterTab, self);
			self.callbackChangeEvent = callbackChangeEvent;
			
			// 내부 사용 element
			self.$bFilterTopWrap = self.$layFilter.find("div.anchor_choice"); // b필터 상단 영역	
			self.$bFilterListWrap = self.$layFilter.find("div.filter-list-wrap");
			self.$bPlpFilterWrap = self.$layFilter.find("div.plp-filter-wrap");
		},

		_bindEvents: function () {
			var self = this;
	
			//<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 모바일 전용 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
			/**
			 * 모바일 필터박스 열기
			 */
			self.$resultWrap.on("click", ".ico-filter", function (e) {
				e.preventDefault();
				
				$('.cont-wrap').children('.lay-filter').addClass('active');
				$('.cont-wrap .lay-filter-con').addClass('active');
				// [mo] 필터 탭 정보 활성화 변경
				setTimeout(function () {
					self.changeFilterTabInfo();
				}, 260)
				
				$("html").addClass("filter-open");
			});
		
			/**
			 * 모바일 필터박스 닫기
			 */
			self.$layFilter.on("click", ".filter-close button, .filter-bottom .btn-group > a", function (e) {
				e.preventDefault();
				setTimeout(function () {
					$('.cont-wrap .lay-filter-con').removeClass('active');
					$('.cont-wrap .lay-filter').removeClass('active');
					$("html").removeClass("filter-open");
				}, 200);
				
				// LGECOMVIO-20 앱 하단 바 비노출
				lgkorUI.showAppBottomMenu(true);
				lgkorUI.setEnableAppScrollBottomMenu(true);
			});
		
			/**
			 * dim 클릭시 모바일 필터박스 닫기
			 */
			self.$layFilter.find(".dimmed").on("click", function (e) {
				e.preventDefault();
				setTimeout(function () {
					$('.cont-wrap .lay-filter-con').removeClass('active');
					$('.cont-wrap .lay-filter').removeClass('active');
					$("html").removeClass("filter-open");
				}, 200);
				
				// LGECOMVIO-20 앱 하단 바 비노출
				lgkorUI.showAppBottomMenu(true);
				lgkorUI.setEnableAppScrollBottomMenu(true);
			});
			
			/**
			 * [mo] 필터 카테고리 뒤로가기
			 */
			self.$layFilter.on("click",".category-list-wrap button",function (e) {
				e.preventDefault();
				var unitName = this.dataset.unit_name;
				
				var tagetEl = self.$bFilterListWrap.find(".filter-inner > div.list-acco." + unitName);
					tagetEl.find('.category-list-wrap > div').each(function (idx, item) {
					var ctgType = this.dataset.ctgType;
					if(ctgType == 'lCtg') {
						$(item).removeClass('sub');
					} else {
						$(item).addClass('sub');
					}
				});
			});
			
			//<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 모바일 전용 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
			/**
			 * 검색 레이어 데이터 갱신
			 */
			//a필터
			self.$aFilterTab.siblings(".nafilter_anchor").on("click", ".btn-dict, .slide-btn", function (e) {
				var infoUrl  =$(e.currentTarget).data("infoUrl");
				var infoType  =$(e.currentTarget).data("infoType");
				if (infoUrl && infoUrl.length > 0) {
					if (infoType == "S") {
						self.smartFilterSpecInfoAjax(infoUrl);
					} else {
						self.smartFilterInfoAjax( infoUrl);
					}
				}
			});
			//b필터
			self.$layFilter.on("click", ".btn-dict, .slide-btn", function (e) {
				var infoUrl  =$(e.currentTarget).data("infoUrl");
				var infoType  =$(e.currentTarget).data("infoType");
				if (infoUrl && infoUrl.length > 0) {
					if (infoType == "S") {
						self.smartFilterSpecInfoAjax(infoUrl);
					} else {
						self.smartFilterInfoAjax( infoUrl);
					}
				}
			});
			//안내 버튼 닫기
			$('.dict-pop').on('click', '.btn-close', function() {
				$('html, body').removeClass('hidden').removeAttr('style');
				$('.wrap').removeAttr('style');
				$('.dict-pop').removeClass('scroll');
				$('#popupDictionary').empty();
			});
			
			$(document).on('click', '.ui_modal_dim', function(e) {
				$('.dict-pop').find('.ui_modal_close').trigger('click');
			});
			
			// 유닛탭 클릭
			self.$layFilter.on("click", ".anchor_area li > a", function (e) {
				var target = $(e.currentTarget);
				var unitName = target.attr("href").replace("#", "");
				
				self.changeUnitTab(unitName);
			});
	
			// 태그형 x 버튼
			self.$bFilterTopWrap.on("click", ".s-filter-list li button", function (e) {
				e.preventDefault();
			
				var target = $(e.currentTarget);
				var unitName = target.data("unit");
				var id = removeSpaces(target.data("contents"));
				var value = target.data("value") || "";
			
				if (value) {
					value = value + "";
				}
			
				// 가격 필터면
				if (value.indexOf("PRICE@") > -1) {
					// bfilter 에서 가격 슬라이드 찾아
					var $rangeSlider = self.$layFilter.find(
						'li .ui_slider[name="bfilter-' + unitName + "-" + id + '"]'
					);
			
					if ($rangeSlider.length > 0) {
						var rangeSlider = $rangeSlider.data("ui_rangeSlider");
					
						var valueArr = value.replace("PRICE@", "").split("||");
						var rangeArr = [valueArr[0], valueArr[valueArr.length - 1]];
					
						// 초기화
						rangeSlider.reset(rangeArr.join(","));
					
						self.triggerChangeEvent({ unit:  unitName }); // 재검색 발생
					}
			
					return;
				}
			
				if (unitName && id && value) {
					var selector = unitName + "-" + id + "'][value='" + value + "']";
					var checked = false;
					
					var $input = self.$bFilterListWrap.find(
						"li input[name='bfilter-" + selector
					);
					
					// 라디오면 첫번째 e.g "전체" 를 클릭해 현재 checked 제거
					if ($input.is("[type=radio]")) {
						var defaultRdoINPUT = $input
							.closest(".rdo-wrap")
							.parent()
							.children()
							.eq(0)
							.find("input");
						
						if (defaultRdoINPUT.length && defaultRdoINPUT.val() === "") {
							$input = defaultRdoINPUT;
							checked = true;
						}
					}

					// bfilter 내에 input change 이벤트 trigger
					$input.prop("checked", checked).change();
				}
			});
	
			// bfilter input change 이벤트 처리
			self.$layFilter.on("change",".ui_filter_accordion input[id^=bfilter], .filter-top-wrap input[id^=bfilter]" , function (e) {
				var target = $(e.currentTarget);
				var unitName = target.closest("li[data-filter-unit]").data("filter-unit");

				self.triggerChangeEvent({ unit: unitName });
			});
	
			// bfilter input click 이벤트 처리 (bfilter 에서만 변경 시 유닛 위치로 이동하는 기능 때문에 추가)
			self.$layFilter.on("click",".ui_filter_accordion input[id^=bfilter], .filter-top-wrap input[id^=bfilter]", function (e) {
				var target = $(e.currentTarget);
				var unitName = target.closest("li[data-filter-unit]").data("filter-unit");
				// 현재 보이는 활성화 된 유닛과 변경 일으킨 필터의 유닛이 다른 경우 해당 유닛으로 리스트 위치 변경
				if (self.activatedUnitName !== unitName) {
					self.changeUnitTab(unitName);
				}
			});
	
			// bfilter 초기화버튼 이벤트 처리 (pc, mo 마크업 각각)
			self.$layFilter.on("click","a.head_reset, .btn-refresh",function (e) {
				e.preventDefault();
			
				self.resetBfilter();
			});
			
			// 미디어 쿼리
			$(window).on(
				"breakpointchange.search",
				self.breakpointChecker.bind(self)
			);
			
			// B필터 스크롤 이벤트
			var $filterInnter = self.$layFilter.find(".lay-filter-con");
			$filterInnter.on("scroll.filterlayer", function (e) {
				var target = e.currentTarget;
			
				// 모바일 b필터에 그림자 넣기 위한 css class
				if (self.device === "mobile") {
				  $(target).toggleClass("is_scroll", target.scrollTop > 0);
				}
			});
		},

		//스마트 필터 안내연동
		smartFilterInfoAjax: function (ajaxUrl) {
			var self = this
			//ajax호출
			lgkorUI.requestAjaxData(ajaxUrl, null, function (result) {
				var data = result.data; 
				$('#popupDictionary').html(vcui.template(grossaryTemplate, data[0].gramFilterGlossary.glossaryInfo));
			});
		},
		//스펙 용어사전 연동
		smartFilterSpecInfoAjax: function (ajaxUrl) {
			lgkorUI.requestAjaxData("/search/retrieveFilterGlossary.lgajax?id="+ajaxUrl, null, function (result) {
				result.data.forEach(function (obj, idx) {
					if (obj.description) {
						//개행문자가 \n으로 넘어와서 개행처리
						var specDescription = vcui.string.escapeHTML(obj.description);
						specDescription = specDescription.replace(/(?:\r\n|\r|\n)/g, "<br/>");
						obj.description = specDescription;
					}
				});
				if (result.data.length == 1) {	//용어사전 제공타입 T:텍스트, I:이미지, V:비디오, H:html
					$('#popupDictionary').html(vcui.template(specGrossaryTemplate, result.data[0]));
				}else {	//Image Slider 
					$('#popupDictionary').html(vcui.template(specGrossarySliderTemplate, result));
					
					//vcui.require(['ui/carousel'], function () {
						$('.dictionary-slider-wrap').find('.ui_carousel_slider').vcCarousel({
							infinite: true,
							swipeToSlide: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							prevArrow:'.btn-arrow.prev',
							nextArrow:'.btn-arrow.next',
							adaptiveHeight:false,
							lazyLoad:'anticipated',
							cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
							touchThreshold: 100,
							speed: 150
						});
					//});
	
					$('.dictionary-slider-wrap').find('.ui_carousel_slider').on('carouselinit', function(e,target,index){
						var dictCarouselSlider = $('.dictionary-slider-wrap').find('.ui_carousel_slider');
						var dictCarouselSlideLast = parseInt(dictCarouselSlider.find('.ui_carousel_slide:last').attr('data-ui_carousel_index'));
						if(dictCarouselSlideLast == 0) {
							dictCarouselSlider.find('.slide-controls').hide();
						} else {
							dictCarouselSlider.find('.slide-controls').children('.slide-number').children('span').text(dictCarouselSlideLast);
						}
					});
	
					$('.dictionary-slider-wrap').find('.ui_carousel_slider').on('carouselafterchange', function(e,target,index){
						$('.dictionary-slider-wrap').find('.slide-number').children('.current').text(index + 1);
					});
				}
			});
		},
		breakpointChecker: function () {
			var self = this;
			var breakpoint = window.breakpoint;
		
			self.device = breakpoint.name;
		
			switch (breakpoint.name) {
				case "pc":
					// 모바일용 그림자 css class 제거
					self.$layFilter.find(".lay-filter-con").removeClass("is_scroll");
					
					// 모바일 b필터 열려있으면 닫기
					if (self.$layFilter.hasClass("open"))
						self.$layFilter.find(".filter-close button").click();
					break;
				case "mobile":
					break;
				default:
			}
	
			// afilter
			self.AFilter.breakpointChecker();
		},
	
		/**
		 * bfilter 생성
		 * @param {object} data 검색 전체 데이터
		 */
		create: function (data, savedData) {
			if (!data) return;
			
			var self = this;
			
			// 내부 생성자 require 완료되지 않았다면 데이터만 저장
			if (!self.loaded) {
				self.resultData = data;
				return;
			}
			
			self.resultData = data;
			if (savedData) self.selectedData = savedData; // 유닛별 필터그룹 만들때 선택된 "검색결과" 데이터가 필요하여
			
			self.saveUIState();
			
			// layout 초기화
			self.$layFilter.css("display", "");
			self.$layFilter.closest(".cont-wrap").removeClass("bottom"); // intersection 내에 정의한 .bottom 초기화
			self.$bFilterListWrap.empty();
			self.$layFilter.find(".filter-top").hide(); // 기획에 없는데.. 일단 숨김
			
			self.$bFilterTopWrap.find(".choice_area ul.s-filter-list").empty();
			
			// ajax res의 필터데이터만 추출 (항시 노출할 "검색결과" 필터와 병합 반환)
			self.filterData = self.sumFilterData(data);
			
			// afilter
			self.AFilter.create();
			
			// 그려질 필터 그룹 배열 (위 병합한 self.filterData 와 매칭위해 "unit" 추가)
			// ["unit", "product", ...]
			var filterGroupArr = ["unit"].concat(
				_.find(_.get(self.selectedData, "unit.filterData"), _.isArray) ||
				self.units // 첫진입 시 저장된 필터 정보 없을 때 "unit" + self.units 기반으로 생성 (전체 체크 효과) // 일단 triggerChangeEvent() 되어야 self.selectedData 생기므로
			);
			
			// self.units 순서대로 생성 (위 병합한 self.filterData 와 매칭위해 "unit" 추가)
			// ["unit", "new", "product" ...]
			_.each(["unit"].concat(self.units), function (unitName) {
				var arr = [];
				var unitData = self.filterData[unitName];
			
				if (!unitData) return;
			
				// filterData, smartFilter 한 배열로 합침
				// arr = [{filterId: '제품타입', ... }, {filterId: '공기청정면적', ... }, ..]
				_.forIn(unitData, function (value, key) {
					_.each(value, function (item) {
						item.smart = key === "smartFilter" ? "Y" : "N"; // 스마트필터 구별 위함
						if (item.filterValues && item.filterValues.length > 0) {
							// filterValues 있는 것만
							arr.push(item);
						}
					});
				});
				
				if (filterGroupArr.indexOf(unitName) === -1) return; // 그려질 필터그룹 배열에 내용 없으면 필터생성 안하도록 중지
				
				if (arr.length) {
					// bfilter - 유닛별 그룹 생성
					self.$bFilterListWrap.append(
						vcui.template(tempBfilterGroup, {
							unitName: unitName,
							unitNameKor: _.get(data.data[unitName], "unitName", ""), // data 에 "검색결과" 관련은 데이터는 없기 때문에 '' 처리
						})
					);
					
					// "검색결과" 필터 버튼으로 // v1.5
					if (unitName === "unit") {
						// 재검색 시 활성화 기억
						var unitTabId = self.getUIState("bfilter.unit");
	
						if(!self.$bFilterTopWrap.find(".anchor_area .tabs li").length) {
							self.$bFilterTopWrap.find(".ui_tab ul.tabs").append(vcui.template(tempUnitBtn, { data: arr[0], act: unitTabId }));
						}

						// 2개 미만 일때 탭영역 숨김 위해
						var unitBtnLen = _.filter(_.get(arr[0], "filterValues"),function (item) {
							return parseInt(item.count) > 0;
						}).length;
					
						self.$layFilter.toggleClass("hide-tab", unitBtnLen < 2);
					}
					
					// afilter
					self.AFilter.createUnitBtn(unitName, arr);
					self.AFilter.createFilterBtn(unitName, arr);
					
					var tempInput; // replace 할 tempalte 변수
					arr.forEach(function (item, index) {
						// 필터별 반복
						item.index = index;
						item.unitName = unitName;
						//---가공
						item._filterInfoYN =  ( item.smart=="Y" && item.filterInfoAjaxUrl && item.filterInfoTitle && item.filterInfoType && item.filterInfoTitle !="" && item.filterInfoAjaxUrl !="" && item.filterInfoType !="") ?  "Y" : "N";
						if(item._filterInfoYN == "Y"){
							item._filterInfoTitle	= item.filterInfoTitle; 
							item._filterInfoAjaxUrl = item.filterInfoAjaxUrl;
							item._filterInfoType	= item.filterInfoType;
						} else{
							item._filterInfoTitle	= ""; 
							item._filterInfoAjaxUrl = ""; 
							item._filterInfoType	= "";
						}
						item._id = removeSpecials(removeSpaces(item.filterId));
						
						item.filterValues.forEach(function (obj, idx) {
							// count
							obj.count = !isNaN(obj.count) ? vcui.number.addComma(obj.count) : null;
							// value
							obj.filterValueName = obj.topFilterDisplayName ? obj.topFilterDisplayName : obj.filterValueName;
						});
						
						switch (item.filterType) {
							case "range":
								var priceArr			= _.get(item, "filterValues[0].filterValueId");
								item._range = priceArr[0] + "," + priceArr[priceArr.length - 1];
								tempInput = tempRangeSlider;
								break;
							case "color":
								// 색상이면 filterValues 두개로 나눠 저장
								var sold = _.filter(item.filterValues, function (color) {
									return (
										color.filterValueName.match(/\//i) === null &&
										color.filterCode.indexOf("objet_") !== 0
									); // 색상명 "/" 아니고 && 코드로 앞 objet_ 아닐때
								});
							
								var objet = _.filter(item.filterValues, function (color) {
									return (
										color.filterValueName.match(/\//i) !== null ||
										color.filterCode.indexOf("objet_") === 0
									); // 색상명 "/" || 코드로 앞 objet_ 이면 오브제
								});
							
								_.set(item, "filterValues_Sold", sold);
								_.set(item, "filterValues_Objet", objet);
							
								tempInput = tempColor;
								break;
							case "radio":
								tempInput = tempRadio;
								break;
							case "checkbox":
								if( item.unitName === "product" && item.filterId === "producttype") {
									tempInput = tempSpanCheckbox;
								} else {
									tempInput = tempCheckbox;
								}
								break;
							default:
								tempInput = tempCheckbox;
						}
						
						// bfilter
						_.set(item, "area", "bfilter");
			        	//partnerType[제휴사 타입](AFC:복지몰, AFF: 임직원몰, ENT:사업자, LGE:LG전자임직원, B2C:일반)
			            if ($("div.contents.search").attr("data-partner-type") == "AFC" || $("div.contents.search").attr("data-partner-type") == "AFF" || $("div.contents.search").attr("data-partner-type") == "LGE") {
			            	_.set(item, "isEmp", true);
			            }else {
			            	_.set(item, "isEmp", false);
			            }
						_.each(item.filterValues, function (value, idx) {
							// index값 저장($index로 바인딩 안됨), input[id], label[for]의 고유 구분자로 활용
							_.set(value, "_idx", idx);
							// filterEnable boolean 값 vcui.template() 위해 "Y" || "N" 로 변경
							_.set(value,"_filterEnable",value.filterEnable == false ? "N" : "Y");
						});
							
						// [정렬 / tag template]
						if(item.unitName === "product" && item.filterId === "producttype" ) {
							// isEmp가 false인 경우 체크 하여  li 만들지..말자..
							_.set(item, "_empDispYn", "Y");
							if(item.filterValues.length == 1) {
								item.filterValues.forEach(function (obj, idx) {
									if(item.isEmp == false && obj.filterValueId == "partner") {
										_.set(item, "_empDispYn", "N");
									}
								});
							
							} 
							if(!self.$bFilterListWrap.find(".filter-top-wrap").length) {
								var filterTopTmp = '<div class="filter-top-wrap"><ul></ul></div>';
								self.$bFilterListWrap.find(".filter-inner p").after(vcui.template(filterTopTmp));
							}
							self.$bFilterListWrap
								.find(".filter-top-wrap > ul")
								.append(vcui.template(unitTopTitleTemplate.replace(/\{\{\_input\_\}\}/g, tempInput),item));
						// tag
						} else if(item.unitName === "product" && item.filterId === "tag" ) {
							if(!self.$bFilterListWrap.find(".filter-top-wrap").length) {
								var filterTopTmp = '<div class="filter-top-wrap"><ul></ul></div>';
								self.$bFilterListWrap.find(".filter-inner p").after(vcui.template(filterTopTmp));
							}
							self.$bFilterListWrap.find(".filter-inner .filter-top-wrap > ul")
								.append(vcui.template(topTagTemplate.replace(/\{\{\_input\_\}\}/g, tempInput),item));
						// [가격 template]
						} else if(item.filterType === "range") {
							self.$bFilterListWrap.find(".filter-inner > div.list-acco." + unitName + "> ul")
								.append(vcui.template(priceTemplate.replace(/\{\{\_input\_\}\}/g, tempInput),item));
						// [카테고리 template]
						} else {
							self.$bFilterListWrap
								.find(".filter-inner > div.list-acco." + unitName + "> ul")
								.append(vcui.template(tempAccordion.replace(/\{\{\_input\_\}\}/g, tempInput),item));
						}
						// afilter
						self.AFilter.addSwiperSlide(unitName, item, tempInput);
					}); // end forEach
					
				}
			}); // end each
			
			self.initVcui();
			self.AFilter.initVcui();
		},
		
		/**
		 * bfilter 영역의 vcui 초기화 (.create() 에서 실행)
		 */
		initVcui: function () {
			var self = this;
	
			// 유닛 탭 // v1.5
			var tab = self.$bFilterTopWrap.find(".ui_tab").data("ui_tab");
			if (tab) tab.update();
			
			// 아코디언
			self.$layFilter.find(".ui_filter_accordion").vcAccordion();
	
			// 아코디언 expand 이벤트
			self.$layFilter.off("accordionexpand.expand")
						   .on("accordionexpand.expand",".ui_filter_accordion", function (e, data) {
				var $rangeSlider = data.content.find(".ui_slider");
				if ($rangeSlider.length > 0) {
					var rangeSlider = $rangeSlider.data("ui_rangeSlider");
					if (!rangeSlider) {
						$rangeSlider.vcRangeSlider();
					} else {
						rangeSlider.update(true);
					}
				}
			});
			
			// 슬라이더 초기화
			self.$layFilter.find(".ui_slider").each(function () {
				var $rangeSlider = $(this);
				var rangeArr = $rangeSlider.data("range").split(",");
				
				// 슬라이더 중간 값 설정
				if (rangeArr.length > 1) {
					var min = parseInt(rangeArr[0]);
					var max = parseInt(rangeArr[1]);
					var step = (max - min) / 100;
						step = Math.round(step);
				
					var arr = _.range(min, max + step, step);
					rangeArr = arr.map(function (val) {
						return { value: val };
					});
					
					// min, max 값 같은 경우 비활성화
					var diff = _.reduce([min, max], function (a, b) {
						return a - b;
					});
					
					if (!diff) {
						self.disabledFilter($rangeSlider.closest("li"), true);
					}
					
					if(min == max) {
						$rangeSlider.addClass('same');
					}
				}
	
				$rangeSlider.vcRangeSlider({
					values: rangeArr,
					roundUnit: step,
				});

				// ga 데이터 세팅(partnerprice, subscribeprice).
				var debouncedSetDataLayer = _.debounce(function(e, min, max) {
					if (e.type === "rangesliderchanged") {
						self.setDataLayer(e, min, max);
					}
				}, 300);
		
				// 슬라이더 change 이벤트
				$rangeSlider.on("rangesliderinit rangesliderchange rangesliderchanged", function (e, data) {
					var $rangeSlider = $(e.currentTarget);
					var $min = $rangeSlider.siblings(".min");
					var $max = $rangeSlider.siblings(".max");
					var suffix = $rangeSlider.data("suffix");
					
					var min = !isNaN(data.minValue)
						? data.minValue
						: data.minValue.value;
					var max = !isNaN(data.maxValue)
						? data.maxValue
						: data.maxValue.value;
					
					if (suffix) {
						$min.text(vcui.number.addComma(min) + suffix);
						$max.text(vcui.number.addComma(max) + suffix);
					} else {
						$min.text(min);
						$max.text(max);
					}
					
					$rangeSlider.attr("data-value", min + "," + max);
					if (e.type === "rangesliderchanged") {
						var target = $(e.currentTarget);
						var unitName = target
							.closest("li[data-filter-unit]")
							.data("filter-unit");
						
						self.triggerChangeEvent({ unit: unitName });
						
						// 현재 보이는 활성화 된 유닛과 변경 일으킨 필터의 유닛이 다른 경우 해당 유닛으로 리스트 위치 변경
						if (self.activatedUnitName !== unitName) {
							self.changeUnitTab(unitName);
						}
					}
					
					if(min == max) {
						$rangeSlider.addClass('same');
					}

					debouncedSetDataLayer(e, min, max);

				});
				// 필터 가격 금액 노출
				if ($rangeSlider.length > 0) {
					var rangeSlider = $rangeSlider.data("ui_rangeSlider");
					rangeSlider.update(true);
					$rangeSlider.vcRangeSlider();
				}
			});
		},
	
		/**
		 * 저장된 필터데이터 토대로 input 상태변경
		 * @param {object} data {product:{filterData:{제품타입:["공기청정기"]},smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
		 */
		select: function (data) {
			if (!data) return;
		
			var self = this;
		
			if (!self.loaded) {
				self.selectedData = data;
				return;
			}
	
			// 저장데이터 없을 때 "검색결과" 기본 체크위한 data.unit.filterData 강제 생성
			// "검색결과" 전부 활성화
			if (_.isEmpty(data)) {
				var defaultUnit = [];
		
				var resultArea = self.$layFilter.find('li[data-filter-unit="unit"]');
				resultArea.find("input").each(function () {
					defaultUnit.push($(this).val());
				});
				var key = resultArea.data("filter-id");
		
				if (key) {
					_.set(data, "unit.filterData." + key, defaultUnit);
				}
			}
	
			self.selectedData = data;
	
			var $accordions = self.$layFilter.find(".ui_filter_accordion, .filter-top-wrap .flex-chk-wrap");
			var $swiper = self.$resultWrap.find(".nafilter_anchor .swiper");
	
			for (unitName in data) {
				var unit = data[unitName]; // e.g ) unitName : unit || product || support
				
				for (filterName in unit) {
					var filterData = unit[filterName]; // e.g ) filterName : filterData || smartFilter
				
					for (filterId in filterData) {
						var valueArr = filterData[filterId]; // e.g ) valueArr : ["뉴메탈 샤인","아이언그레이"] // key: "색상"
						var id = removeSpecials(removeSpaces(filterId));
						var $rangeSlider = self.$layFilter.find('.ui_slider[name="bfilter-' + unitName + "-" + id + '"]');
					
						if ($rangeSlider.length) {
							// 슬라이더 전용 // 가격 변동이 있는 경우
							var rangeSlider = $rangeSlider.data("ui_rangeSlider");
							
							if (rangeSlider && valueArr.length === 4) {
								var priceValues = _.slice(valueArr, 1, 3).join(","); // e.g) '5000000, 10000000'
								rangeSlider.reset(priceValues);
								
								// 슬라이더 부모 아코디언 열기
								self.openFilterAcco($rangeSlider.closest("li"));
								
								// 다른 가격 비활성화
								var $siblingsRangeSlider = self.$layFilter.find('.ui_slider[name^="bfilter"][data-disabled="Y"]');
								$siblingsRangeSlider.each(
									function (idx, elm) {
										this.disabledFilter($(elm).closest("li"), true);
									}.bind(this)
								);
							}
						} else {
							//input들 활성화
							//check or radio
							var selector;
							valueArr.forEach(function (val) {
								selector = unitName + "-" + id + '"][value="' + val + '"]';
								$accordions.find('input[name="bfilter-' + selector).prop("checked", true);
								// afilter
								$swiper.find('input[name="afilter-' + selector).prop("checked", true);
							});
						}
					}
				}
			}
	
			// 선택 정보 업데이트
			self.$layFilter.find(".ui_filter_accordion li, .filter-top-wrap li").each(function (idx, elm) {
				self.updateWarp($(elm));
			});
	
			// 태그형 상태 갱신
			self.refreshTag();
		},
	
		/**
		 * 필터 선택 정보 업데이트 (필터 갯수만큼 반복 실행 e.g "검색결과", "제품타입", "색상" ...)
		 * @param {jQueryElement} target 필터 li
		 */
		updateWarp: function (target) {
			var self = this;
			var $li = target;
			var $selected = $li.find("input:checked").filter(function () {
				return !(
					!$(this).val().trim().length /*  || $(this).is(":disabled") */
				); // "전체" 거나 || 비횔성화 는 제외 // 위 :disabled 는 필터별 disabled 기능 생겨서 주석 처리합니다. 선택 후 해당 input이 disabled 되면 재선택이 안되므로 tag형 x 버튼으로라도 해제할 장치를 마련
			});
			var $head = $li.find(".head");
			var $label = $head.find(".tit_result_count").next();
			var $result = $head.find(".tit_result_text");
			
			var id = $li.data("filter-id");
			var unitName = $li.data("filter-unit");
			
			var selectedArr = [];
			// [{label: '구매가능 제품', value: 'CT50000143'}, {label: '렌탈가능 제품' ..}]
			
			if (!!$li.find(".ui_slider").length) {
				// 가격
				var $rangeSlider = $li.find(".ui_slider");
				var rangeData = self.getRangeSliderData($rangeSlider);
				
				var values = rangeData.values;
				if (rangeData.isChange && values.length === 4) {
					selectedArr.push({
						label:
							vcui.number.addComma(values[1]) +
							"원 ~ " +
							vcui.number.addComma(values[2]) +
							"원",
						value: "PRICE@" + values.join("||"),
					});
				}
				
			} else {
				if ($label.is(".tit_result_colorchip")) {
				// 컬러
					_.each($selected, function (item) {
						selectedArr.push({ label: item.value, value: item.value });
			
						var $colorchip = $(item).parent().clone();
						$colorchip.find("input").removeAttr("id");
						$colorchip.find("label").removeAttr("for");
						
						// color clip
						if ($label.children().length < 2) {
						  $label.append($colorchip);
						}
					});
				} else {
					// 일반
					_.each($selected, function (item) {
						selectedArr.push({
							label: $(item).next("label").text(),
							value: item.value,
						});
					});
				}
			
				// count
				$result.text(!!selectedArr.length ? selectedArr.length : "");
			}
			
			// 위 가공된 selectedArr 통하여 tag형 버튼 추가
			// afilter // id 가 undefined인 경우 가격 슬라이더형 안에 input 여러개 존재하는 구조로써 발생됨
			if (id) self.addTag(unitName, id, selectedArr);
		},
	
		/**
		 * 태그형 샹태 갱신
		 */
		refreshTag: function () {
			var self = this;
			// 영역 토글
			if (self.$layFilter.find(".select-filter-list ul").find("li").length > 0) {
				self.$layFilter.find('div.lay-filter-con').addClass('sort-cate');
				self.$layFilter.find(".select-filter-list").addClass("on");
			} else {
				self.$layFilter.find('div.lay-filter-con').removeClass('sort-cate');
				self.$layFilter.find(".select-filter-list").removeClass("on");
			}
	
			self.$bFilterTopWrap
				.find(".choice_area")
				.toggle(!!self.$bFilterTopWrap.find("ul.s-filter-list").children().length);
	
			// A필터 카운팅 업데이트
			self.AFilter.refreshTag();
		},
	
		/**
		 * 태그형 버튼 추가
		 * @param {string} unitName 유닛명
		 * @param {string} filterId 필터 id
		 * @param {array} selectedArr 선택된 배열
		 * @returns
		 */
		addTag: function (unitName, filterId, selectedArr) {
			var self = this;
		
			// "검색결과" 는 tag 리스트 안 쌓음
			if (unitName === "unit") return;
		
			// 선택 tag 리스트
			var $selectTagUL = self.$bFilterTopWrap.find("ul.s-filter-list");
		
			$selectTagUL.append(
				vcui.template(tempSelectTag, {
					unitName: unitName,
					filterId: filterId,
					data: selectedArr,
				})
			);
		
			// afilter
			self.AFilter.addTag(unitName, filterId, selectedArr);
		},
	
		/**
		 * 탭 활성화 변경
		 * @param {string} id // 버튼 a태그 href #뺀 id
		 */
		changeTab: function (id) {
			var self = this;
			
			var $tab = self.$bFilterTopWrap.find(".ui_tab");
			var $tabB = $tab.find("a[href='#" + id + "']");
			
			if (!$tabB.length) return;
			
			var tab = $tab.data("ui_tab");
			var $li = $tabB.closest("li");
			var idx = $li.index();
			var marginLeft = parseInt($li.css("marginLeft"));
			
			if (tab) {
				tab.select(idx);
				var left = $li.get(0).offsetLeft - marginLeft;
					left = left - 16;		// 첫번째 탭 영역 위치 처리(-16) 
				
				$tabB.closest(".tabs")
				 .get(0)
				 .scrollTo({ left: left, behavior: "smooth" });
			}
		},
	
		//<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 모바일 전용 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
		/**
		 * [mo] 필터 탭 정보 활성화 변경 
		 */
		changeFilterTabInfo: function () {
			var self = this;
			
			$('div.anchor_choice .tabs > li').each(function(idx, item) {
				if($(item).hasClass('on')) {
					var unitName = $(item).children('a').attr("aria-controls");
					
					// MO 탭 상세 정보 set
					self.setChangeFilterTabInfo(unitName);
					
					// 필터 그룹 토글
					self.toggleFilter(unitName);
				}
			});
			
		},
		
		/**
		 * 디폴트 : 첫번째 탭 활성화 (초기화시 가장 늦게 처리됨으로 활성화 변경(changeFilterTabInfo)으로 처리불가)
		 */
		changeFilterTabFirstInfo: function () {
			var self = this;
			
			$('div.anchor_choice .tabs > li').each(function(idx, item) {
				if(idx == 0) {
					var unitName = $(item).children('a').attr("aria-controls");
					
					// MO 탭 상세 정보 set
					self.setChangeFilterTabInfo(unitName);
					
					// 필터 그룹 토글
					self.toggleFilter(unitName);
				}
			});
			
		},
		
		/**
		 * MO 탭 상세 정보 set
		 */
		setChangeFilterTabInfo: function (unitName) {
			if(unitName) {
				$('.filter-list-wrap > div').each(function(idx, item) {
					$(item).removeClass('active');
					if( unitName === $(item).data('filter-group-id')) {
						$(item).addClass('active');
						
						// rangeSlider update
						setTimeout(function () {
							$('.ui_slider').each(function() {
								var rangeSlider = $(this).data("ui_rangeSlider");
								rangeSlider.update(true);
							});
						}, 20)
						
						// 각탭의 총 결과 노출
						$('.result-list-wrap .list-wrap').each(function() {
							if($(this).hasClass(unitName)) {
								var allviewEl = $(this).find('div.result-allview_area .result-allview')[0];
								if(typeof allviewEl != "undefined") {
									var filterCnt = allviewEl.dataset.allResultCnt;
									$('.lay-filter .btn-group span').text(vcui.number.addComma(filterCnt)+'개 결과보기');
								}
							}
						});
					}
				});
				
				// 모바일 탭 초기화 버튼 disabled 처리
				$('.filter-bottom button.btn-refresh').prop("disabled", ($('.s-filter-list li').length > 0 ? false : true));
			}
			
			setTimeout(function () {
				lgkorUI.showAppBottomMenu(false);
				lgkorUI.setEnableAppScrollBottomMenu(false);
			}, 10)
		},
		
		//<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 모바일 전용 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
		
		/**
		 * 스크롤 위치에 따른 필터 그룹 토글
		 * @param {string} unitName 유닛명
		 */
		toggleFilter: function (unitName) {
			var self = this;
			
			// 유닛탭 활성화 변경 // v1.5
			self.changeTab(unitName);
			
			// 유닛탭 활성화 기억
			// intersection scrollDirection의 방향과 상관없이 활성화 기억을 위해
			self.setUIState("bfilter.unit", unitName);
			
			var $bfilterGroupDIV = self.$bFilterListWrap.find(".filter-inner > div").not(".unit");
			var $targetAcco = $bfilterGroupDIV.filter("." + unitName);
			
			// 직전 상태와 같으면 진행 안함
			if ($targetAcco.hasClass("on")) return;
			
			// bfilter
			$bfilterGroupDIV.each(function (idx, elm) {
				var $acordion = $(elm); // div.ui_filter_accordion
				var disabled = !$acordion.hasClass(unitName);
				
				// 비활성화
				$acordion.toggleClass("on", !disabled); // css 스타일 아닌 현재 inview 유닛 파악을 위해 필요
				
				if (disabled) {
					// 활성화된 unitName 을 css 클래스로 가지고 있지 않은 아코디언
					// 아코디언 닫기
					self.closeFilterAccoAll($acordion);
				} else {
					// 활성화된 unitName 을 css 클래스로 가지고 있는 아코디언
					var $rangeSlider = $acordion
						.find(".ui_slider[data-disabled='Y']")
						.closest("li")
						.siblings()
						.find(".ui_slider")
						.eq(0); // 값이 설정되었으면 하나는 disabled 이기에 이를 활용하여 선택된 rangeSlider 찾음
					
					if ($rangeSlider.length) {
					} else {
						$acordion
							.find("> ul > li input:checked")
							.filter(function () {
								return !!$(this).val().trim().length; // "전체" 제외
							})
						.each(function (idx, elm) {
							var $input = $(elm);
							var $li = $input.closest("li");
							var label = $input.next("label").text();
							
							self.openFilterAcco($li);
						});
						
						// 탭 클릭시 아코디언 선택 없으면 첫번째 아코디언 OPEN
						if($acordion.hasClass(unitName)) {
							var isChck=false;
							$(".ui_filter_accordion."+unitName+" > ul > li").each(function (idx, elm) {
								if( $(elm).find('input').is(':checked')) {
									if(!!$(elm).val().length) {
										isChck = $(elm).find('input').is(':checked');
									}
								}
							});
							if(!isChck) {
								if( unitName === 'product') {
									$acordion.find("> ul > li").each(function (idx, elm) {
										if(elm.dataset.filterId === 'category') {
											var tAcordion = $acordion.find("> ul > li").eq(idx);
											self.openFilterAcco(tAcordion.closest("li"));
										}
									});
								} else {
									var tAcordion = $acordion.find("> ul > li").eq(0);
									self.openFilterAcco(tAcordion.closest("li"));
								}
							}
						}
					}
				}
			});
		
			self.AFilter.toggle(unitName);
			
			// 최초 전입, 재검색 activatedUnitName = null 로 인해 안타고 이후 변경이 일어나면 inViewBfilterUnit 실행
			if (self.activatedUnitName && self.activatedUnitName !== unitName) {
				self.inViewBfilterUnit(unitName);
			}
			
			self.activatedUnitName = unitName;
		},
	
		/**
		 * 필터 비활성화
		 * @param {jQueryElement} target li[data-filter-id]
		 * @param {boolean} partial 개별 유무 (toggleFilter()에 영향 없도록.. e.g 구매가격, 렌탈가격)
		 */
		disabledFilter: function (target, partial) {
			var self = this;
			var $filterLI = target;
			var $filterCont = $filterLI.children('div').find('.cont');
			
			if (partial) {
				$filterLI.attr("data-disabled", "Y");
				$filterCont.addClass('range-disabled');
			}
			
			$filterLI.find(".head").addClass("inactive");
			$filterLI.find(".flex-chk-wrap.check-filter input").prop("disabled", true);
			
			// 클릭 방지
			$filterLI
				.find(".link-acco")
				.removeClass("ui_accord_toggle")
				.on("click.disabled", function (e) {
					e.preventDefault();
				});
		},
	
		/**
		 * 필터 활성화
		 * @param {jQueryElement} target li[data-filter-id]
		 * @param {boolean} partial 개별 유무 (toggleFilter()에 영향 없던것.. e.g 구매가격, 렌탈가격)
		 */
		enabledFilter: function (target, partial) {
			var self = this;
			var $filterLI = target;
			
			if (partial) {
				$filterLI.removeAttr("data-disabled");
			} else if ($filterLI.attr("data-disabled") === "Y") {
				// 개별 disabled 한 경우 풀지 않음
			  return;
			}
			
			$filterLI.find(".head").removeClass("inactive");
			$filterLI.find(".flex-chk-wrap.check-filter input").prop("disabled", false);
			
			// 클릭 방지 복구
			$filterLI
				.find(".link-acco")
				.addClass("ui_accord_toggle")
				.off(".disabled");
		},
	
		/**
		 * 선택한 항목 있는 아코디언 열기
		 * @param {jQueryElement} li 아코디언 li
		 */
		openFilterAcco: function (li) {
			var idx = li.index();
			var $acordion = li.closest('div[ui-modules="Accordion"]');
			
			if ($acordion.length) {
				var acc = $acordion.data("ui_accordion");
			
				setTimeout(function () {
					if (acc) acc.expand(idx, false);
				}, 10); // accordion.js 내부 초기화 딜레이로 타이밍 안맞아 같이 딜레이 줘야함
			}
		},
		
		/**
		 * 유닛내에 아코디언 전체 닫기
		 * @param {jQueryElement} acco ui-modules="Accordion" 적용된 요소
		 */
		closeFilterAccoAll: function (acco) {
			var $acordion = acco;
		
			if ($acordion.length) {
				var acc = $acordion.data("ui_accordion");
		
				if (acc) acc.collapseAll();
			}
		},
		
		/**
		 * 유닛별 아코디언 전체 열기
		 * @param {string} acco ui-modules="Accordion" 적용된 요소
		 */
		openFilterAccoAll: function (acco) {
			var $acordion = acco;
		
			if ($acordion.length) {
				var acc = $acordion.data("ui_accordion");
		
				if (acc) acc.expandAll();
			}
		},
		
		/**
		 * 스크롤 반응하는 요소 컨틀롤
		 */
		scrollHandler: function () {
			var self = this;
		
			var st = $(window).scrollTop();
			var wh = window.innerHeight;
		
			if (self.device == "pc") {
				var topH = 94;
				var $footer = $("footer");
				var $filterWrap = self.$layFilter.closest(".cont-wrap");
				var $filterInnter = self.$layFilter.find(".lay-filter-con");
		
				if (
					!!$footer.length &&
					!!$filterWrap.length &&
					!!$filterInnter.length
				) {
					var filterBottomYpos = $filterInnter.offset().top + $filterInnter.outerHeight();
					
					var isOverFooter = filterBottomYpos > $footer.offset().top;
					
					if (isOverFooter) {
						var overTop = st + wh - $footer.offset().top;
						self.$layFilter.css("height", wh - topH - overTop); // 높이 조절
						
						$filterWrap.addClass("bottom");
					} else {
						self.$layFilter.css("height", wh - topH); // 높이
						
						$filterWrap.removeClass("bottom");
					}
					
					if (self.$layFilter.is(":hidden")) {
						self.$layFilter.css("height", "");
					}
				}
			} else {
				var $aFilterSwiperTabCon = self.$aFilterTab.siblings(".nafilter_anchor");
				var $aFilterTagCon = self.$aFilterTab.siblings(".nafilter_choice");
				
				if (!!$aFilterTagCon.length && !!$aFilterSwiperTabCon.length) {
					var swiperContH = $aFilterSwiperTabCon.not(":hidden").outerHeight() || 0;
					var isSticky = swiperContH < $aFilterTagCon.get(0).offsetTop - self.$aFilterTab.outerHeight();
					
					// a필터 tag형 마크업 아래 그림자 css 클래스
					// $aFilterTagCon.toggleClass("scroll_sticky", isSticky);
				}
			}
		},
		
		/**
		 * intersection observer 초기화 (좌측 bottom 고정 기능)
		 */
		initIntersection: function () {
			var self = this;
			
			// 대상
			var $footer = $("footer");
			
			if (!$footer.length) return;
			
			// 제거
			self.desposeIntersection();
			
			self.intersection = new IntersectionObserver(
				function (entries) {
					var entrie = entries[0] || {};
					var inter = entrie.isIntersecting;
					
					var $filterWrap = self.$layFilter.closest(".cont-wrap");
					
					if (inter) {
						if (!vcui.detect.isMobile) $filterWrap.addClass("bottom");
					} else {
						$filterWrap.removeClass("bottom");
					}
				},
				{
					threshold: [0],
					rootMargin: "-" + window.innerHeight + "px 0px 0px 0px",
				}
			);
		
			self.intersection.observe($footer.get(0));
		},

		/**
		 * intersection observer 제거
		 */
		desposeIntersection: function () {
			if (self.intersection) {
				self.intersection.disconnect();
				self.intersection = null;
			}
		},

		/**
		 * afilter 변경에 따른 bfilter 상태 변경
		 * @param {jQueryElement} target afilter input
		 */
		changeBfilter: function (target) {
			var self = this;
			
			if (target) {
				var id = target.attr("id");
			
				if (id) {
					id = id.replace(/\w+\-(?=\w)/i, "#bfilter-");
					var bfilterInput = $(id);
			
					bfilterInput.prop("checked", target.prop("checked"));
			
					var unitName = bfilterInput.closest("li[data-filter-unit]").data("filter-unit");
			
					self.triggerChangeEvent({ unit: unitName });
				}
			}
		},

		/**
		 * bfilter 초기화
		 * @param {*} target
		 */
		resetBfilter: function () {
			var self = this;
		
			// 전부 해제
			self.$layFilter.find("input").prop("checked", false);
		
			// unit 전부 선택
			self.$layFilter
				.find('li[data-filter-unit="unit"] input')
				.not(":disabled")
				.prop("checked", true);
		
			// 슬라이더 전부 초기값
			self.$layFilter.find(".ui_slider").each(function () {
				var $rangeSlider = $(this);
				var rangeSlider = $rangeSlider.data("ui_rangeSlider");
				var rangeData = self.getRangeSliderData($rangeSlider);
			
				if (rangeSlider && rangeData.range) {
					rangeSlider.reset(rangeData.range.join(",")); // e.g) '0, 10000000'
				}
			});
			
			self.triggerChangeEvent(); // 재검색 발생
			
			$(window).scrollTop(0); // 리셋했으니 스크롤 최상단으로
		},

		/**
		 * 유닛탭 클릭
		 */
		changeUnitTab: function (unitName) {
			var self = this;
			self.$layFilter.trigger(self.event.CLICK_UNIT_TAB, unitName);
			self.setChangeFilterTabInfo(unitName);
		},
		
		/**
		 * 필터 input checked 수정 함수
		 * @param {string} unitName 유닛명
		 * @param {string} id 필터 id
		 * @param {string} value 필터 value
		 * @param {boolean} checked 체크 여부
		 */
		changeFilterInput: function (unitName, id, value, checked) {
			var self = this;
			var input = self.getFilterInput(unitName, id, value);
			if (self.activatedUnitName && self.activatedUnitName !== unitName) {
				this.changeUnitTab(unitName);
			}
			input.prop("checked", checked);
			input.change();
		},
		
		/**
		 * 사용자 interection 에 따른 객체 외부로 콜백
		 * @param {object} data 특정 유닛의 결과만 변경을 위한 인자
		 * @param {string} data.unit 유닛명
		 */
		triggerChangeEvent: function (data) {
			var self = this;
			self.callbackChangeEvent(self.getDataFromFilter(data));
		},
		
		/**
		 * ui 상태 저장
		 */
		saveUIState: function () {
			var self = this;
			// b필터 스크롤 ypos 저장 ()
			var bfilterYpos = self.device === "pc"
				? self.$layFilter.scrollTop() || 0
				: self.$layFilter.find(".lay-filter-con").scrollTop() || 0;
		
			self.setUIState("bfilter.ypos", bfilterYpos);
		},

		/**
		 * ui 상태 복구함수
		 */
		restoreUIState: function () {
			var self = this;
			// 화면 조정
			self.$layFilter.one(self.event.READY_RESTORE, function () {
				var bfilterYpos = self.getUIState("bfilter.ypos");
				
				if (self.device === "pc") {
					self.$layFilter.scrollTop(bfilterYpos);
					// 유닛탭 활성화 복구
					var unitTabId = self.getUIState("bfilter.unit");
					if (unitTabId) self.changeTab(unitTabId);
				} else if (self.device === "mobile") {
					self.$layFilter.find(".lay-filter-con").scrollTop(bfilterYpos);
					
					if (self.AFilter) self.AFilter.restoreUIState();
					
					// [mo] 필터 탭 정보 노출
					self.changeFilterTabInfo();
				}
			});
		
			// pc & mobile 분기
			var $listenerTarget;
			var selector;
			switch (self.device) {
				case "pc":
					$listenerTarget = self.$layFilter;
					selector = ".ui_filter_accordion, .filter-top-wrap";
					break;
				case "mobile":
					$listenerTarget = self.$resultWrap;
					selector = ".result-list";
					break;
				default:
					$listenerTarget = $($.fn);
			}
		
			// 높이에 영향을 주는 아코디언 초기화 및 확장이 모두 끝나면 trigger
			if (!!$listenerTarget.length && selector) {
				$listenerTarget.off("accordionexpand.all");
		
				// 아코디언 accordionexpand 호출 안되는 상황 (전부 닫혀 accordionexpand 호출 안 될때)
				self.$layFilter.trigger(self.event.READY_RESTORE);
		
				$listenerTarget.on( "accordionexpand.all", selector, _.debounce(function () {
					$listenerTarget.off("accordionexpand.all");
		
					self.$layFilter.trigger(self.event.READY_RESTORE);
				}, 100));
			}
		},

		/**
		 * bitler 활성화 유닛 inview
		 */
		inViewBfilterUnit: function (unitName) {
			var self = this;
			var target = self.$bFilterListWrap.find("> ." + unitName);
			var isBottom = self.$layFilter.parent().is(".bottom");
			
			// 필터내에 활성화 아코디언 스크롤 위치 변경, 바닦에 붙었을땐 사용안함
			if (target.length && !isBottom) {
				setTimeout(function () {
					var paddingTop =
						parseInt(self.$bFilterListWrap.css("paddingTop")) || 0;
					
					self.$layFilter.scrollTop(target.get(0).offsetTop - paddingTop);
				}, 10); // accordion.js 내부 초기화 딜레이로 타이밍 안맞아 같이 딜레이 줘야함
			}
		},
		
		/**
		 * filterlayer 전용 필터데이터 반환
		 * @param {object} data 검색 전체 데이터의 data 값
		 * @returns
		 */
		makeFilterData: function (data) {
			var filterList = _.pickBy(data, function (value) {
				// filter 정보있는 맴버만 반환
				return value.filterList && _.defaultTo(value.smartFilterList, []);
			});
			
			_.forIn(filterList, function (item, unitName) {
				filterList[unitName] = _.mapKeys(
					// key명 가공
					// filterList > filterData
					// smartFilterList > smartFilter
					_.pick(item, ["filterList", "smartFilterList"]), // 맴버 filter
					function (value, key) {
						return key == "filterList" ? "filterData" : "smartFilter";
					}
				);
			});
			
			return filterList;
		},

		/**
		 * 항시 노출할 unit 필터와 ajax res의 필터 데이터와 병합 반환
		 * @param {object} data 검색 전체 데이터
		 * @return
		 */
		sumFilterData: function (data) {
			var self = this;
		
			// data 토대로 unit용 filterData 생성
			var unitFilterData = {
				// unit: [{filerId: "검색결과", ...}]
				unit: {
					filterData: [
						{
							filterId: "검색결과",
							filterValues: _.map(self.units, function (item) {
								var count = parseInt(_.get(data, "data." + item + ".count", 0));
								var value = _.get(data, "data." + item + ".unitName");
								
								return {
									filterValueName: value,
									filterValueId: item,
									count: count,
								};
							}),
							filterGroupName: "검색결과",
							filterGroupType: "checkbox",
							filterType: "checkbox",
						},
					],
					smartFilter: [],
				},
			};
		
			// ajax res 데이터를 filterlayer 사용할 필터 데이터로 변경
			var filterData = self.makeFilterData(data.data);
			
			return _.merge({}, unitFilterData, filterData);
		},

		/**
		 * 필터 선택 상태 토대로 data 반환 ( FilterLayout Callback 데이터로 사용 )
		 * {product:{filterData:{제품타입:["공기청정기"]},smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
		 * @param {object} param 특정 유닛의 결과만 변경을 위한 인자
		 * @param {string} param.unit 유닛명
		 * @returns
		 */
		getDataFromFilter: function (param) {
			var self = this;
			var param = param || {};
			var unitName = param.unit;
			
			var data = {
				filterData: {},
				smartFilter: {},
			};
	
			// input 별 반복, slider 추가 반복
			self.$layFilter.find(".ui_filter_accordion .ui_accord_content input[id^=bfilter], .ui_slider, .filter-top-wrap input[id^=bfilter]").each(function (idx, el) {
				var $li = $(el).closest("li[data-filter-unit]");
				var $ul = $li.closest("ul");
				var filterId = $li.data("filter-id"); // 제품타입 || 색상 || 화면5575
				var filterName = $li.data("contents"); // 제품타입 || 색상 || 화면 55~75
				var unitName = $li.data("filter-unit"); // unit || product
				var isSmart = lgkorUI.stringToBool($li.data("filter-smart")); // 'Y' || 'N'
				var filterCase = !isSmart ? "filterData" : "smartFilter";
	
				if (unitName) {
					// 자신이 속한 유닛 기반으로 필터 데이터 _.set()
					var path = filterCase + "." + unitName + ".";
			
					if ($(el).is(".ui_slider")) {
						// 슬라이더 전용
						var rangeData = self.getRangeSliderData($(el));
						if (rangeData.isChange) {
							// 슬라이더가 변경 되었으면 데이터 저장
							_.set(data, path + filterName, rangeData.values);
						}
					} else {
						// 일반 input 형
						if ( el.checked && !(el.value == null || !el.value.trim().length) ) {
							// 최상위 뎁스 선택된 것이 없으면 하위 선택 필터 모두 제거 위함
							var isOneDepthChecked = !!$ul.find("> li:eq(0) input[id^=bfilter]:checked").not('[value=""]').length;
						
							// product 유닛은 isOneDepthChecked 무관하게 무조건 checked value 저장
							if (isOneDepthChecked || unitName === "product" || unitName === "subscribe" || unitName === "subspackage" ) {
								if (!_.get(data, path + filterName)) {
									_.set(data, path + filterName, []);
								}
							
								_.get(data, path + filterName).push(el.value);
							}
						}
					}
				}
			}); // each
	
			// unit 전용 json의 payload 데이터 // "검색결과" 은 제외
			if (unitName && unitName !== "unit") {
				// unit 전용 filterData, smartFilter 제공 // 위 data 의 filterData, smartFilter 와 다른건 유닛명이 중간에 빠져서 제공됨
				var unitFilterData = _.mapValues(data, unitName);
				unitFilterData.unit = unitName;
		
				_.merge(data, {
					unitFilterData: unitFilterData,
				});
			}
		
			// 전체보기에 의한 호출 구분자
			if (param.isMore) data.isMore = param.isMore;
		
			return data;
		},

		/**
		 * range 데이터 반환
		 * @param {jQueryElement} $el .ui_slider
		 * @returns {{ range:array, value:array, values: array, isChange: boolean }}
		 * // range - min,max, value - 설정값, values - 조합된 값 , isChange - 변경 유무
		 */
		getRangeSliderData: function ($el) {
			// 슬라이더 전용
			var $rangeSlider = $el;
			var originalValues = _.compact(
				($rangeSlider.attr("data-range") || "").split(",")
			);
			var currentValues = _.compact(
				($rangeSlider.attr("data-value") || "").split(",")
			);
			var values = [];
		
			// 설정된 값과 min, max와 비교하여 차이가 있다면 data에 넣어 반환
			if (_.difference(currentValues, originalValues).length) {
			// min, max 포함 반환 // [min, cur1, cur2, max]
				if ((currentValues.length === 2, originalValues.length === 2)) {
					values = _.concat(
						originalValues[0],
						currentValues,
						originalValues[1]
					);
				}
			}
		
			return {
				range: originalValues,
				value: currentValues,
				values: values,
				isChange: values.length > 2,
			};
		},

		/**
		 * 선택된 input 기반의 "검색결과" 필터 데이터 반환
		 * @returns {object} {unit: {검색결과: ["product","support"]
		 */
		getUnitFilterData: function () {
			var self = this;
			var units = [];
			self.$bFilterListWrap.find(".filter-inner > div.unit input:checked").each(function () {
				units.push(this.value);
			});
			
			return _.set({}, "unit.검색결과", units);
		},

		/**
		 * 필터 input 반환
		 * @param {string} unitName 유닛명
		 * @param {string} id 필터 id
		 * @param {string} value 필터 value
		 */
		getFilterInput: function (unitName, id, value) {
			var self = this;
			var selector = unitName + "-" + id + '"]';
			var input = self.$bFilterListWrap.find('input[name="bfilter-' + selector);
			if (value) {
				input = input.filter('[value="' + value + '"]');
			}
			
			return input;
		},

		/**
		 * 검색 결과 데이터 반환
		 * @returns
		 */
		getResultData: function () {
			var self = this;
		
			return self.resultData;
		},

		/**
		 * uiState 저장
		 * @param {string} path
		 * @param {*} value
		 */
		setUIState: function (path, value) {
			var self = this;
		
			_.set(self.uiState, path, value);
		},

		/**
		 * usState 반환
		 * @param {string} path
		 * @returns
		 */
		getUIState: function (path) {
			var self = this;
		
			if (!path) return self.uiState;
		
			return _.get(self.uiState, path);
		},

		/**
		 * GA 이벤트 추적을 위한 dataLayer 설정 함수
		 *
		 * @param {jQuery.Event} e 이벤트 객체
		 * @param {object} min 슬라이더 최소 가격
		 * @param {object} max 슬라이더 최대 가격
		 * @returns {void}
		 */
		setDataLayer: function (e, min, max) {
			var $rangeSlider = $(e.currentTarget);
			var $li = $rangeSlider.closest("li[data-filter-id]");
			if (!$li.length) return;

			var filterId = $li.data("filter-id");
			if (!filterId || (filterId !== "partnerprice" && filterId !== "subscribeprice")) return;

			var priceRange = vcui.number.addComma(min) + " - " + vcui.number.addComma(max) + "원";
			
			var eventAction = (filterId === "partnerprice") ? "필터 - 구매가격" : "필터 - 가격범위가격";

			if (typeof dataLayer !== "undefined" && dataLayer) {
				dataLayer.push({
					'event': 'customEvent',
					'customEventCategory': '필터',
					'customEventAction': eventAction,
					'customEventLabel': priceRange
				});
			}
		}
	};
	return FilterLayer;
})();
//BTOCSITE-93811
$(document).on('ready',function(){
	if($('.cont-wrap.w-filter .lay-filter').length == 1){
		$('.cont-wrap.w-filter .lay-filter').css('visibility','hidden');
	}
});
$(window).on('load',function(){
	for(var i=0; i<10; i++){
		(function(i){
			setTimeout(function(){
				if($('.cont-wrap.w-filter .lay-filter').length == 1){
					$(window).trigger('scroll');
					$('.cont-wrap.w-filter .lay-filter').css('visibility','visible');
				}
			},300 * i);
		})(i);
	}
});